import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * ImageBlock – image with optional caption. Supports label + gradient.
 */
const ImageBlock = ({ label, gradient, src, alt = '', caption, captionColor, captionFontSize, fontSize, fontFamily, paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, width = '100%', borderRadius = 2, boxShadow, border, borderColor, componentAlignment = 'left', textAlign, }) => {
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : 'transparent';
    const align = textAlign || componentAlignment;
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 3,
            paddingBottom: paddingBottom || 3,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 900, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 2, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsx(Box, { sx: {
                        width,
                        maxWidth: '100%',
                        borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius,
                        overflow: 'hidden',
                        boxShadow: boxShadow || '0 1px 3px rgba(0,0,0,0.08)',
                        border,
                        borderColor: borderColor || 'divider',
                    }, children: _jsx("img", { src: src || 'https://via.placeholder.com/800x400?text=Image', alt: alt, style: { width: '100%', height: 'auto', display: 'block' } }) }), caption && (_jsx(Typography, { variant: "body2", sx: {
                        mt: 1.5,
                        textAlign: align,
                        color: captionColor || 'text.secondary',
                        fontSize: captionFontSize || fontSize || '0.9rem',
                        fontFamily: fontFamily || undefined,
                        fontStyle: 'italic',
                    }, children: caption }))] }) }));
};
export default ImageBlock;
